/**
 *
 * Constants
 *  Applications constants...
 *
 * @author     K. van den Broek <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

import GLOBAL from './global';
import MAPS from './maps';
import URLS from './urls';

export default {
  GLOBAL,
  MAPS,
  URLS
};
